import React, { useRef, useState, useEffect, Suspense } from 'react';
import useHttpApiCall from '../../../services/useHttpApiCall';
import { useLocation } from 'react-router';
import { lineTempAndHumChartFilterButtons } from '../../../config/chartFilterButtons';
import { customWidgetEndpointLayers, customWidgetEndpoints } from '../../../config/widgetEndpoints';
import widgetApiParams from '../../../utilities/widget.api.params';
import { useSelector } from 'react-redux';
import MachineLayoutComponent from '../../machinedetail/components/machinelayout.component';
import heatmapAirQualityConfig from '../../../common/chartdataconfig/heatmap.airquality.config';
import { heatmapChartValues } from './customgraph.heatmap.configs';
import RefreshHeatmap from '../../../common/chartautorefresh/refresh.heatmap';
import DateRangeSet from '../../../common/datetimepicker/daterangeset';

export default function CustomAirQualityContainer(props) {
  //console.log("air quality" ,props)
  const INITIALFILTER = '1day';
  // const [chartData, setChartData] = useState(undefined);
  const charRef = useRef(undefined);
  const [chartApiData, setChartApiData] = useState([]);
  const [payload, setPayload] = useState(undefined);
  const [payload2, setPayload2] = useState(undefined);
  const [selectEquipments, setSelectEquipments] = useState(null);
  const set_equipment_filter = useSelector((state) => state.equipmentFilter.set_equipment_filter);
  const [graphFilter, setGraphFilter] = useState({
    filterMain: INITIALFILTER
  });
  const [filterByDateCheck, setFilterByDateCheck] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [apiDateRange, setApiDateRange] = useState([]);

  const graphInfo = {
    isSummaryGraph: false
  };
  const onSidbarClick = useSelector((state) => state.sidebarClick.linkClick);
  const [apiParams, setApiParams] = useState(null);
  const [lastTimeStamp, setLastTimeStamp] = useState(null);
  const location = useLocation();
  const userAccessibility = useSelector((state) => state.userAccessibility.set_user_accessibility);
  const flexibleEquipmentEnabled =
    localStorage.getItem('flexible_equipment') == 'true' ? true : false;

  const config = {
    ...heatmapAirQualityConfig({
      chartApiData,
      graphFilter,
      graphName: props.graph_name || props.name,
      userAccessibility,
      heatmapChartValues: heatmapChartValues[props.slug]
    })
  };

  const graphApiCall = () => {
    flexibleEquipmentEnabled
      ? setPayload({
          auth: true,
          url: `${
            flexibleEquipmentEnabled
              ? customWidgetEndpointLayers?.airQuality
              : customWidgetEndpoints.airQuality
          }`,
          params: {
            ...apiParams,
            aq_index: props?.end_point || props?.aq_index,
            layer_type: props?.layer_type,
            plant_code: props?.plant_code,
            layer_id: props?.graph_type_id
          }
        })
      : setPayload({
          auth: true,
          url: `${
            flexibleEquipmentEnabled
              ? customWidgetEndpointLayers.airQuality
              : customWidgetEndpoints.airQuality
          }`,
          params: { ...apiParams, aq_index: props?.end_point || props?.aq_index }
        });
    charRef.current.chart.zoomOut();
    charRef.current.chart.showLoading();
  };

  const graphAddPointApiCall = () => {
    // eslint-disable-next-line no-unused-vars
    const { duration, ...modifiedParams } = apiParams;
    flexibleEquipmentEnabled
      ? setPayload2({
          auth: true,
          url: flexibleEquipmentEnabled
            ? customWidgetEndpointLayers.airQuality
            : customWidgetEndpoints.airQuality,
          params: {
            ...modifiedParams,
            last_reading_time: lastTimeStamp,
            aq_index: props?.end_point || props?.aq_index,
            layer_type: props?.layer_type,
            plant_code: props?.plant_code,
            layer_id: props?.graph_type_id
          }
        })
      : setPayload2({
          auth: true,
          url: flexibleEquipmentEnabled
            ? customWidgetEndpointLayers.airQuality
            : customWidgetEndpoints.airQuality,
          params: {
            ...modifiedParams,
            last_reading_time: lastTimeStamp,
            aq_index: props?.end_point || props?.aq_index
          }
        });
  };

  useEffect(() => {
    if (onSidbarClick) {
      setGraphFilter((prev) => ({
        ...prev,
        filterMain: INITIALFILTER,
        filterSecondary: graphFilterObject[INITIALFILTER].dropdown[0]
      }));
      charRef.current.chart.zoomOut();
    }
  }, [onSidbarClick]);

  useEffect(() => {
    if (apiParams) {
      graphApiCall();
    }
  }, [apiParams]);

  useEffect(() => {
    if (
      set_equipment_filter.filter_update &&
      set_equipment_filter.params.sub_division == props.sub_division
    ) {
      graphApiCall();
    }
  }, [set_equipment_filter.filter_update]);

  useEffect(() => {
    if (graphFilter || location.pathname) {
      setApiParams(
        widgetApiParams(
          'ProcessInstantaneousPower',
          props,
          graphFilter,
          filterByDateCheck,
          apiDateRange,
          INITIALFILTER
        )
      );
    }
  }, [graphFilter, location.pathname]);

  const graphFilterObject = lineTempAndHumChartFilterButtons;
  const [data, loading] = useHttpApiCall(payload);
  useEffect(() => {
    if (data && data.data) {
      let apiData = data.data.data;
      setChartApiData(apiData);
      setSelectEquipments({
        equipment_length: apiData.equipments_count,
        is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
        equipmet_list_api_url: 'v0/equipments/',
        equipmet_list_params: {
          get_equipment_preference: 1,
          sub_division: props.sub_division,
          process_id: apiData.process_id
        },
        drilldown_level: 'custom',
        equipment_update_params: {
          sub_division: props.sub_division,
          process_id: apiData.process_id
        }
      });
      setLastTimeStamp(apiData.last_updated_time);
      charRef.current.chart.hideLoading();
    }
  }, [data]);

  return (
    <div>
      <Suspense fallback={<span>Loadiing</span>}>
        <MachineLayoutComponent
          chartApiData={chartApiData}
          loading={loading}
          chartData={config}
          charRef={charRef}
          expandWindow={props.expandWindow}
          minimizeWindow={props.minimizeWindow}
          shouldExpand={props.shouldExpand}
          chartId={props.id}
          hasFilter={true}
          graphFilter={graphFilter}
          setGraphFilter={setGraphFilter}
          graphFilterObject={graphFilterObject}
          selectEquipments={selectEquipments}
          filterByDate={true}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          maxSelectionDays={props?.layer_type == 'temp_hum' ? 90 : 30}
        />
        {filterByDateCheck && (graphFilter.filterMain == null || graphFilter.filterMain == '') ? (
          ''
        ) : (
          <RefreshHeatmap
            data={data}
            payload2={payload2}
            charRef={charRef}
            apiParams={apiParams}
            chartApiData={chartApiData}
            setChartApiData={setChartApiData}
            lastTimeStamp={lastTimeStamp}
            setLastTimeStamp={setLastTimeStamp}
            graphApiCall={graphApiCall}
            graphAddPointApiCall={graphAddPointApiCall}
          />
        )}
        <DateRangeSet
          graphFilter={graphFilter}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          setGraphFilter={setGraphFilter}
          initialFilter={INITIALFILTER}
          setApiDateRange={setApiDateRange}
          graphInfo={graphInfo}
        />
      </Suspense>
    </div>
  );
}
